import { z } from 'zod';
import { NATIONAL_EXPENDITURE_NATURE_CODE_LENGTH } from '../utils';
import { getCodeMaxValue } from '../utils/get-code-max-value';

const NationalExpenditureNatureBaseModel = z.object({
  id: z.string().uuid(),
  createdAt: z.string(),
  updatedAt: z.string(),
  code: z
    .number()
    .min(1)
    .max(getCodeMaxValue(NATIONAL_EXPENDITURE_NATURE_CODE_LENGTH)),
  name: z.string(),
  startYear: z.number().int().nullish(),
  endYear: z.number().int().nullish(),
  isTransferMoney: z.boolean(),
});

export const NationalExpenditureNatureModel =
  NationalExpenditureNatureBaseModel;

export const NationalExpenditureNaturesModel =
  NationalExpenditureNatureBaseModel.array();
